import React, {useState} from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DriverSearchInput from "./SearchInput";


import DriverOrderReportTable from './ReportTable';

function OrdersTab() {
    const [searchValue, setSearchValue] = useState("");
    
    const updateSearchValue = (value) => {
      setSearchValue(value);
    }


  return (
    <div>
      <Container maxWidth={false}>
       
        <DriverOrderReportTable searchInput={searchValue} updateSearchValue={updateSearchValue} />
      </Container>
    </div>
  );
}

export default OrdersTab;
